import React from "react";
import PropTypes from "prop-types";

const CalendarIcon = ({
  width,
  height,
  className,
  color,
  fill,
  selected,
  ...props
}) => {
  const fillColor = fill && fill !== "none" ? fill : color || "#475569";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66699 8.66667C6.66699 8.29848 6.96547 8 7.33366 8H10.667C11.0352 8 11.3337 8.29848 11.3337 8.66667C11.3337 9.03486 11.0352 9.33333 10.667 9.33333H7.33366C6.96547 9.33333 6.66699 9.03486 6.66699 8.66667ZM4.66699 8.66667C4.66699 8.29848 4.96547 8 5.33366 8H5.33965C5.70784 8 6.00631 8.29848 6.00631 8.66667C6.00631 9.03486 5.70784 9.33333 5.33965 9.33333H5.33366C4.96547 9.33333 4.66699 9.03486 4.66699 8.66667ZM4.66699 11.3333C4.66699 10.9651 4.96547 10.6667 5.33366 10.6667H8.66699C9.03518 10.6667 9.33366 10.9651 9.33366 11.3333C9.33366 11.7015 9.03518 12 8.66699 12H5.33366C4.96547 12 4.66699 11.7015 4.66699 11.3333ZM9.99434 11.3333C9.99434 10.9651 10.2928 10.6667 10.661 10.6667H10.667C11.0352 10.6667 11.3337 10.9651 11.3337 11.3333C11.3337 11.7015 11.0352 12 10.667 12H10.661C10.2928 12 9.99434 11.7015 9.99434 11.3333Z"
        fill={fillColor}
      />
      <path
        d="M4.66634 1.33341C4.66634 0.965225 4.36786 0.666748 3.99967 0.666748C3.63148 0.666748 3.33301 0.965225 3.33301 1.33341V1.63265C3.58656 1.55222 3.8567 1.4948 4.14323 1.45315C4.30853 1.42913 4.48282 1.40992 4.66634 1.39457V1.33341Z"
        fill={fillColor}
      />
      <path
        d="M12.6663 1.63265C12.4128 1.55222 12.1427 1.4948 11.8561 1.45315C11.6908 1.42913 11.5165 1.40992 11.333 1.39457V1.33341C11.333 0.965225 11.6315 0.666748 11.9997 0.666748C12.3679 0.666748 12.6663 0.965225 12.6663 1.33341V1.63265Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.68585 1.3335H7.31415C6.01529 1.33348 4.96761 1.33346 4.14355 1.45323C3.28356 1.57823 2.5712 1.84537 2.01201 2.4499C1.45966 3.04703 1.22186 3.79531 1.10944 4.69927C0.999978 5.57946 0.999988 6.70287 1 8.11608V8.55091C0.999988 9.96411 0.999978 11.0875 1.10944 11.9677C1.22186 12.8717 1.45966 13.62 2.01201 14.2171C2.5712 14.8216 3.28356 15.0888 4.14355 15.2138C4.96761 15.3335 6.01529 15.3335 7.31415 15.3335H8.68584C9.9847 15.3335 11.0324 15.3335 11.8564 15.2138C12.7164 15.0888 13.4288 14.8216 13.988 14.2171C14.5403 13.62 14.7781 12.8717 14.8906 11.9677C15 11.0875 15 9.96411 15 8.5509V8.1161C15 6.70288 15 5.57946 14.8906 4.69927C14.7781 3.79531 14.5403 3.04703 13.988 2.4499C13.4288 1.84537 12.7164 1.57823 11.8564 1.45323C11.0324 1.33346 9.98471 1.33348 8.68585 1.3335ZM2.99855 6.00017C2.6928 6.00017 2.53993 6.00017 2.44257 6.09627C2.34521 6.19238 2.34325 6.34331 2.33933 6.64517C2.33351 7.09395 2.33333 7.59629 2.33333 8.16233V8.50467C2.33333 9.97457 2.33455 11.0149 2.43258 11.8032C2.52885 12.5773 2.70842 13.0064 2.99081 13.3117C3.26637 13.6096 3.64313 13.7937 4.33533 13.8943C5.05238 13.9985 6.00284 14.0002 7.36667 14.0002H8.63333C9.99717 14.0002 10.9476 13.9985 11.6647 13.8943C12.3569 13.7937 12.7336 13.6096 13.0092 13.3117C13.2916 13.0064 13.4712 12.5773 13.5674 11.8032C13.6655 11.0149 13.6667 9.97457 13.6667 8.50467V8.16233C13.6667 7.59629 13.6665 7.09395 13.6607 6.64517C13.6568 6.34331 13.6548 6.19238 13.5574 6.09627C13.4601 6.00017 13.3072 6.00017 13.0014 6.00017H2.99855Z"
        fill={fillColor}
      />
    </svg>
  );
};

CalendarIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  fill: PropTypes.string,
  selected: PropTypes.bool,
};

CalendarIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  fill: undefined,
  selected: false,
};

export default CalendarIcon;
